<template>
<b-navbar toggleable="md" type="dark" variant="dark">
  <b-navbar-toggle target="nav_collapse" />
  <b-navbar-brand to="/">MBN</b-navbar-brand>
  <b-collapse id="nav_collapse" is-nav>
    <b-navbar-nav>
      <b-nav-item-dropdown text="Produkter" right>
        <b-dropdown-item v-for="category in categories" :key="category" :to="`/produkter/${category}`" class="products">{{ category }}</b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item to="/about">Om</b-nav-item>
      <b-nav-item to="/contact">Kontakt</b-nav-item>
    </b-navbar-nav>
    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <login />
    </b-navbar-nav>
  </b-collapse>
</b-navbar>
</template>

<script>
import Login from '@/components/Login'
export default {
  name: 'Navigation',
  components: {
    "login": Login
  },
  data() {
    return {
      categories: [
        'blæser',
        'blæserstyring',
        'frøbander',
        'kanaler',
        'luftfordelerkasser',
        'hessian',
        'hovedkanaler',
        'opretning',
        'kornkanoner',
        'kædeelevatorer',
        'redlere',
        'varmekanoner',
        'trugsnegle',
        'rørsnegl',
        'omrører til korn',
        'studser'
      ]
    }
  }
}
</script>

<style scoped>
.products {
  text-transform: capitalize;
}
</style>
